import { Controller } from "@hotwired/stimulus"

// Mascara 000.000.000-00 enquanto digita. So apresentacao: quem valida os
// digitos verificadores e o model (Residente#cpf_valido).
export default class extends Controller {
  format() {
    const d = this.element.value.replace(/\D/g, "").slice(0, 11)
    let v = d
    if (d.length > 9) v = `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6, 9)}-${d.slice(9)}`
    else if (d.length > 6) v = `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6)}`
    else if (d.length > 3) v = `${d.slice(0, 3)}.${d.slice(3)}`
    this.element.value = v
  }
}
